export default {"src":"/_next/static/media/check-border.917bcc4d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};